import React from "react";
class SelectDueDatePage extends React.Component {

  constructor(props){
    super(props);
    let paymentDueDate = props.paymentDueDate;
    if (paymentDueDate) {
      let ExtractedDate = paymentDueDate.split('/')[1];
      if (ExtractedDate) {
        ExtractedDate = parseInt(ExtractedDate);
        const paymentDueDay = this.getOrdinalNum(ExtractedDate);
        this.state = {
          paymentDueDay: paymentDueDay
        };
      }
    }
  }
   getOrdinalNum =(n) =>{
     return n + (n > 0 ? ['th', 'st', 'nd', 'rd'][(n > 3 && n < 21) || n % 10 > 3 ? 0 : n % 10] : '');
   }

    render = () => {
      return (
        <div>
          <div className="your-loan-details margin-t-25 margin-bottom-10">Payment due date</div>

          <div className="your-loan-light-grey font-weight-400">{this.state.paymentDueDay} of every month
          </div>
           
          <p className="display-text-small font-weight-400"> This is the day your payments will be due each month.
            Your payment due date can be modified in the Loan Servicing site.
          </p>
        </div>
      );
    }
}

export default SelectDueDatePage;
